import { EMPTY } from "rxjs";
import { filter, retry, switchMap } from "rxjs/operators";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { PersistenceMode } from "../../../utils/PersistenceMode";
import { utilPersistence } from "../../../utils/utilPersistence";
import { utilServerPersistence } from "../../../utils/utilServerPersistence";
import { TypeServerPersistenceInfo } from "../actionServerPersistence";
export var epicSetServerPersistence = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeServerPersistenceInfo.SetServerPersistence &&
            action.serverPersistence.value !== undefined &&
            action.serverPersistence.key !== undefined;
    }), switchMap(function (action) {
        var keyValuesAddOrReplace = [action.serverPersistence];
        utilPersistence.setValue(action.serverPersistence.key, utilServerPersistence.convertServerPersistenceValue(action.serverPersistence.key, action.serverPersistence.value), PersistenceMode.Write);
        return deps.netSend({
            id: CommandCode.PlayerPreferencesStorage,
            props: {
                keyValuesAddOrReplace: keyValuesAddOrReplace,
                playerId: selectPlayerInfo(state$.value).playerId,
            },
        });
    }), retry(), switchMap(function () { return EMPTY; }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/server-persistence/epics/epicSetServerPersistence.ts
// module id = 2330
// module chunks = 3